const nl = {
  common: {
    cancel: "Annuleren",
    close: "Sluiten",
    done: "Klaar",
    refresh: "Vernieuwen",
    select: "Selecteren",
    clear: "Wissen",
    submit: "Verzenden",
    setDate: "Datum instellen",
    loading: "LADEN ....",
    feedback: "Feedback",
    genericError: "Er is iets misgegaan!",
    yes: "Ja",
    no: "Nee",
    saveChanges: "Wijzigingen opslaan",
    noDataFound: "Geen gegevens gevonden!",
    learnMore: "Meer informatie",
  },
  navigation: {
    home: "Home",
    packageDeals: "Pakketreizen",
    flightSchedules: "Vluchtschema's",
    aboutUs: "Over ons",
    contactUs: "Contact",
    faq: "FAQ",
    jobs: "Vacatures",
    entryFee: "Entry fee",
    myAccount: "Mijn account",
    logIn: "Inloggen",
    signUp: "Aanmelden",
    logOut: "Uitloggen",
    chooseCountry: "Kies een land",
  },
  auth: {
    loginTitle: "Inloggen bij Satyam Holidays",
    loginSubtitle: "Welkom terug. Log in om te boeken en je reizen te beheren.",
    password: "Wachtwoord",
    enterEmail: "E-mailadres",
    enterPassword: "Wachtwoord",
    forgotPasswordQuestion: "Wachtwoord vergeten?",
    forgotPassword: "Wachtwoord vergeten",
    forgotPasswordSubtitle:
      "Vul je e-mail in en we sturen instructies om je wachtwoord te resetten.",
    forgotPasswordInstructions:
      "Controleer je inbox voor instructies om je wachtwoord te wijzigen. Zie je de e-mail daar niet, controleer dan ook je spammap.",
    submitEmail: "Resetlink versturen",
    noAccount: "Nog geen account?",
    createAccount: "Account aanmaken",
    registerSubtitle:
      "Maak een Satyam Holidays-account aan om sneller te boeken en al je reizen bij te houden.",
    enterFirstName: "Voer je voornaam in",
    enterLastName: "Voer je achternaam in",
    enterPhoneNumber: "Voer je telefoonnummer in",
    heardFrom: "Van gehoord via",
    heardAboutUs: "Hoe heb je over ons gehoord?",
    referralFriend: "Via een vriend",
    tvRadioAd: "TV- of radioreclame",
    newspaperMagazine: "Krant of tijdschrift",
    flyerBrochure: "Flyer of brochure",
    other: "Anders",
    otherFieldRequired: "Dit veld is verplicht wanneer je Anders kiest",
    thisField: "Dit veld",
    pleaseSpecify: "Specificeer:",
    agreeTo: "Ik ga akkoord met het",
    privacyPolicy: "Privacybeleid.",
    alreadyHaveAccount: "Heb je al een account?",
    verifyCode: "Code verifiëren",
    noEmail: "Geen e-mail ontvangen?",
    resend: "Opnieuw verzenden",
    missingToken: "Authenticatietoken ontbreekt",
    verifyError: "Er is een fout opgetreden bij het verifiëren van de code.",
  },
  languageModal: {
    title: "Taal en valuta",
    description: "Kies je voorkeurstaal en valuta",
    language: "Taal",
    currency: "Valuta",
    save: "Opslaan en doorgaan",
  },
  languages: {
    english: "Engels",
    dutch: "Nederlands",
  },
  footer: {
    reservations: "Reserveringen",
    onlineTool: "Gebruik onze online tool",
    becomeMember: "Word lid",
    registerPoints: "Registreer nu om punten te verdienen",
    contactUs: "Contact",
    callSuriname: "Bel ons op 1611 in Suriname",
    callEurope: "Bel ons op +31-070-7113625 in Europa",
    version: "Versie {{version}}",
    poweredBy: "Powered by",
    poweredByAria: "Mogelijk gemaakt door DivyAI LLC. Bezoek divyai.com",
    inPartnership: "In samenwerking met",
    inPartnershipAria:
      "Satyam Holidays in samenwerking met DivyAI LLC. Bezoek divyai.com",
    tagline: "Vluchten, pakketreizen en reisondersteuning van Satyam Holidays.",
    explore: "Ontdekken",
    privacy: "Privacybeleid",
    copyright: "© {{year}} Satyam Holidays. Alle rechten voorbehouden.",
  },
  whatsNew: {
    title: "Nieuwe versie beschikbaar",
    version: "Versie {{version}}",
    languageTitle: "Kies je taal",
    cta: "Begrepen",
  },
  changelog: {
    view: "Bekijk changelog",
    title: "Changelog",
    eyebrow: "Productupdates",
    description: "Bekijk wat er per versie is veranderd.",
    latest: "Nieuwste",
    current: "Je gebruikt versie {{version}}",
    changeCount: "{{count}} updates",
  },
  contact: {
    title: "Contact",
    eyebrow: "Contact",
    heading: "Kontakt Ons",
    subtitle:
      "Of je nu je volgende avontuur plant of vragen hebt over een bestaande boeking, ons team staat voor je klaar. Neem contact op en we reageren zo snel mogelijk.",
    ourBranches: "Onze filialen",
    getInTouch: "Neem contact op",
    yourName: "Je naam",
    yourEmail: "Je e-mail",
    yourMessage: "Je bericht",
    quickContact: {
      callLabel: "Bel ons op",
      callOr: "of",
      callValue: "1611 of +597 436950",
      emailLabel: "E-mail ons",
      emailValue: "satyam@satyamholidays.net",
      whatsappLabel: "WhatsApp",
      whatsappValue: "Kies een kantoor",
      callAction: "Bel nu",
      emailAction: "Stuur e-mail",
      whatsappAction: "Start chat",
    },
    whatsappPicker: {
      title: "Chat op WhatsApp",
      subtitle:
        "Kies het kantoor dat het dichtst bij je is en we zetten het gesprek voort in WhatsApp.",
      redirectNotice: "Je wordt doorgestuurd naar WhatsApp.",
    },
    branches: {
      eyebrow: "Onze locaties",
      title: "Bezoek onze kantoren",
      subtitle: "Acht kantoren in vier landen, klaar om je te ontvangen.",
      headOffice: "Hoofdkantoor",
      branchOffice: "Filiaal",
      countries: {
        suriname: "Suriname",
        netherlands: "Nederland",
        india: "India",
        curacao: "Curaçao",
      },
      fields: {
        address: "Adres",
        phone: "Telefoon",
        whatsapp: "WhatsApp",
        hours: "Openingstijden",
      },
      chatButton: "Chat op WhatsApp",
      comingSoon: "Binnenkort",
      officesMeta: "{{offices}} kantoren · {{countries}} landen",
    },
    form: {
      eyebrow: "Stuur ons een bericht",
      title: "Neem contact op",
      subtitle:
        "Vul het formulier in en een teamlid neemt binnen 24 uur contact met je op.",
      name: "Volledige naam",
      namePlaceholder: "Jan de Vries",
      email: "E-mailadres",
      emailPlaceholder: "jij@voorbeeld.nl",
      subject: "Onderwerp",
      subjectPlaceholder: "Waarmee kunnen we helpen?",
      message: "Bericht",
      messagePlaceholder: "Vertel ons kort iets over je vraag...",
      submit: "Bericht versturen",
      sending: "Versturen...",
      successTitle: "Bericht verzonden",
      successMessage:
        "Bedankt voor je bericht. We nemen snel contact met je op.",
      sendAnother: "Stuur nog een bericht",
    },
    visitUs: {
      eyebrow: "Bezoek ons",
      title: "Ons hoofdkantoor",
      address: "Doebestraat # 3, P.O. Box 5145, Kwatta, Paramaribo, Suriname",
      hours: "Ma – Vr  08:30 – 16:30",
      directions: "Routebeschrijving",
    },
  },
  account: {
    tabs: {
      myAccount: "Mijn account",
      myActivities: "Mijn activiteiten",
      tikkie: "Tikkie",
      stripe: "Stripe",
      passportManager: "Paspoortbeheer",
      pnrManager: "PNR-beheer",
      reports: "Rapporten",
    },
    sessionExpired: "De sessie is verlopen, log opnieuw in!",
    eyebrow: "Je profiel",
    profileHint:
      "Houd je gegevens actueel, precies zoals ze op je paspoort staan.",
    personalDetails: "Persoonsgegevens",
    contactDetails: "Contactgegevens",
    security: "Beveiliging",
    memberId: "Lidnummer",
    memberSince: "Lid sinds",
    availablePoints: "Beschikbare punten",
    currentStatus: "Huidige status",
    firstName: "Voornaam",
    lastName: "Achternaam",
    email: "E-mail",
    dateOfBirth: "Geboortedatum",
    phoneNumber: "Telefoonnummer",
    enterPhoneNumber: "Voer telefoonnummer in",
    passportNumber: "Paspoortnummer",
    month: "Maand",
    monthRequired: "Maand is verplicht",
    dateOfBirthInvalid: "Geboortedatum is ongeldig",
    months: {
      january: "Januari",
      february: "Februari",
      march: "Maart",
      april: "April",
      may: "Mei",
      june: "Juni",
      july: "Juli",
      august: "Augustus",
      september: "September",
      october: "Oktober",
      november: "November",
      december: "December",
    },
    changePasswordQuestion: "Wachtwoord wijzigen?",
    saveChanges: "Wijzigingen opslaan",
    updateSuccess: "Je account is succesvol bijgewerkt!",
    oldPassword: "Oud wachtwoord",
    newPassword: "Nieuw wachtwoord",
    confirmPassword: "Bevestig wachtwoord",
    passwordsMustMatch: "Wachtwoorden moeten overeenkomen",
    enterOldPassword: "Voer je oude wachtwoord in",
    enterNewPassword: "Voer je nieuwe wachtwoord in",
    enterConfirmPassword: "Bevestig je nieuwe wachtwoord",
    changePassword: "Wachtwoord wijzigen",
    passwordChanged: "Wachtwoord is succesvol gewijzigd",
  },
  search: {
    airlineCarriers: "Luchtvaartmaatschappijen",
    airport: "Luchthaven",
    airportSearchHint: "Typ minimaal 2 tekens om luchthavens te zoeken",
    airportNoResults: "Geen luchthavens gevonden",
    exampleLocation: "Bijvoorbeeld 'Amsterdam'",
    recentAirports: "Recente zoekopdrachten",
    filterActive: "{{count}} filter actief",
    clearFilter: "Filters wissen",
    pricingTable: "Prijstabel",
    pricingTableTitle: "Prijstabel",
    pricingTableHint: "Vergelijk tarieven op nabije datums",
    pricingCheaper: "Goedkoper",
    pricingHigher: "Duurder",
    pricingTip: "Tip",
    pricingDisclaimer:
      "Klik op een datum in de tabel en onze zoekmachine probeert een betere prijs voor u te vinden.",
    cheaperPriceToastTitle: "Gefeliciteerd!",
    cheaperPriceToast:
      "Onze zoekmachine heeft een goedkopere prijs voor je gevonden.",
    departure: "Vertrek ",
    return: "Terug ",
    noFlights: "Geen vluchten gevonden voor deze datums",
    noFlightsHint:
      "Probeer een andere datum in de prijstabel, of zoek met een tussenstop in de filters om meer opties te zien.",
    noFlightsTipDate: "Kies een andere datum",
    noFlightsTipStop: "Zoek met een tussenstop",
    noFlightsTipFilters: "Pas je filters aan",
    packageDealTitle: "Pakketreisboeking",
    packageDealDescription:
      "Je zoekt vluchten voor een pakketreis. De pakketprijs ({{price}}) wordt toegevoegd aan je vluchtprijs voor het totaalbedrag.",
    checkingAvailability:
      "Even geduld terwijl we controleren of deze vlucht nog beschikbaar is!",
    unavailable: "Deze vlucht is nu niet beschikbaar!",
    modifySearch: "Zoekopdracht aanpassen",
    closeSearch: "Sluiten",
    traveler: "{{count}} reiziger",
    travelers: "{{count}} reizigers",
  },
  faq: {
    eyebrow: "Hulp",
    title: "Veelgestelde vragen",
    description:
      "Duidelijke antwoorden over vluchten, visa, bagage en boekingen. Zoek een onderwerp of blader door de lijst.",
    searchPlaceholder: "Zoek vragen",
    browseTopics: "Onderwerpen",
    questionsCount: "{{count}} vragen",
    questionCountOne: "1 vraag",
    resultsCount: "{{count}} overeenkomende vragen",
    emptyTitle: "Geen vragen gevonden",
    emptyDescription:
      "Probeer een andere zoekterm, of kies een onderwerp uit de lijst.",
    ctaEyebrow: "Support",
    ctaTitle: "Nog geen antwoord gevonden?",
    ctaDescription:
      "Staat je vraag er niet bij? Ons team helpt je graag met je boeking, visum of reisplannen.",
    ctaAction: "Neem contact op",
  },
  aboutUs: {
    heroEyebrow: "Sinds 2006",
    heroTitle: "De mensen achter Satyam",
    heroSubtitle:
      "Een Surinaams reisbureau dat Europa, het Caribisch gebied, Noord Amerika en de wereld verbindt, met zorg, vakmanschap en een persoonlijke aanpak.",
    storyEyebrow: "Onze reis",
    storyTitle: "Van één idee naar een reisbureau",
    tabs: {
      about: "Over ons",
      features: "Functies",
      team: "Team",
      companyInfo: "Bedrijfsinformatie",
    },
    vision: {
      title: "Visie",
      description:
        "In 2028 is SH fysiek bereikbaar in 7 landen en staat het wereldwijd bekend als een prominente, innovatieve en technologiegedreven reisorganisatie van Surinaamse oorsprong.",
    },
    mission: {
      title: "Missie",
      description:
        "De reisexpertise van Suriname trots uitdragen door reizigers wereldwijd te helpen hun avontuurlijke reisdromen waar te maken met hoogwaardige innovatie.",
    },
    features: {
      passportScanner: {
        title: "Paspoortscanner",
        description:
          "Met onze paspoortscanner kun je snel en eenvoudig je paspoort scannen vanaf je telefoon of computer. Geen gedoe meer met papieren documenten bij het reisbureau. Onze paspoortscanner helpt je soepel door het reserveringsproces, zodat je snel op weg bent naar je bestemming.",
        cta: "Klaar om het te proberen? Laten we beginnen!",
      },
      virtualReality: {
        title: "Virtual reality-functie",
        description:
          "Goed nieuws! We werken momenteel aan een virtual reality-functie voor onze webapplicatie voor vluchten die je reiservaring naar een hoger niveau tilt. Met virtual reality kun je je bestemming verkennen zoals nooit tevoren, gewoon vanuit huis. Stel je voor dat je door de straten van Parijs loopt, op de stranden van Hawaï zit of zelfs Mount Everest beklimt - allemaal zonder je woonkamer te verlaten. Onze virtual reality-functie biedt een volledig meeslepende reiservaring, waardoor je kunt zien, horen en voelen alsof je er echt bent.",
        note: "Hoewel we nog in ontwikkeling zijn, kunnen we niet wachten om deze nieuwe functie binnenkort met je te delen. Houd onze updates in de gaten en bereid je voor op het ultieme virtuele reisavontuur!",
      },
    },
    team: {
      eyebrow: "Maak kennis met het team",
      departments: {
        executiveBoard: "Management",
      },
      members: {
        anielB: {
          title: "Oprichter en Chief Executive Officer",
          biography:
            "Aniel B. is de oprichter en huidige CEO van Satyam Holidays. Hij zorgt ervoor dat het bedrijf voorop blijft lopen in de reisbranche en tegelijk de hoogste normen voor ethiek en compliance behoudt. Als CEO leidt hij het bedrijf naar succes door strategische beslissingen te nemen, activiteiten en middelen te beheren en op te treden als het belangrijkste aanspreekpunt tussen het bestuur en de stakeholders van het bedrijf.",
        },
        shivaniB: {
          title: "Chief Marketing Officer",
          biography:
            "Shivani B. is de Chief Marketing Officer. Zij ontwikkelt en implementeert marketingstrategieen om de naamsbekendheid en verkoop te vergroten en zorgt ervoor dat de marketingactiviteiten van het bedrijf aansluiten bij de algemene bedrijfsdoelen.",
        },
        shivaB: {
          title: "Chief Technology Officer",
          biography:
            "Shiva B. is verantwoordelijk voor het vastleggen, analyseren en interpreteren van testgegevens, het voorstellen van verbeteringen en opnieuw testen van producten, het kwalificeren van het eindproduct of systeem, het onderhouden van apparatuur, het voorbereiden van productdocumentatie, het schrijven van rapporten, het geven van presentaties en het monitoren van producten in gebruik om toekomstige ontwerpen te verbeteren.",
        },
        rishiS: {
          title: "Chief Finance Officer",
          biography:
            "Rishi S. is de Chief Finance Officer en is verantwoordelijk voor het beheren van de financiele activiteiten van het bedrijf, waaronder cashflowbeheer en financiele planning, het analyseren van financiele sterke en zwakke punten en het voorstellen van corrigerende maatregelen.",
        },
        afiekB: {
          title: "Operation Manager",
          biography:
            "Afiek B. is de Operation Manager en is verantwoordelijk voor het toezicht op de dagelijkse activiteiten en procedures van het bedrijf, met aandacht voor operationele excellentie en efficientie binnen alle afdelingen.",
        },
        corettaC: {
          title: "Quality Manager",
          biography:
            "Coretta C. is de Quality Manager en is verantwoordelijk voor het waarborgen dat de producten en diensten van het bedrijf voldoen aan vastgestelde kwaliteitsnormen, waaronder betrouwbaarheid, gebruiksvriendelijkheid en prestaties.",
        },
        warshaB: {
          title: "Finance Manager",
          biography:
            "Warsha B. is de Finance Manager en is verantwoordelijk voor het bewaken van de financiele gezondheid van het bedrijf door budgettering, forecasting en financiele rapportage te beheren en naleving van financiele regelgeving te waarborgen.",
        },
        augustI: {
          title: "Adviseur",
          biography:
            "August I. is adviseur. Zijn rol is het geven van strategische begeleiding en deskundig advies aan het leiderschapsteam van het bedrijf, waarmee hij helpt bedrijfsstrategieen vorm te geven en groei te stimuleren.",
        },
        justM: {
          title: "Voor altijd in ons hart",
          biography:
            "Het leiderschap van Just draaide nooit om titels, maar om zorg, integriteit en visie. Hij inspireerde ons om groter te dromen en tegelijk nederig en menselijk te blijven. Zijn nalatenschap leeft voort in het werk waar hij van hield en in de mensen die hij heeft geraakt. Hij was een leidend licht, een luisterend oor en een vriend voor iedereen om hem heen. Zijn bescheidenheid, vriendelijkheid en stille kracht vormden niet alleen onze visie, maar ook de geest van ons team. Hoewel hij niet meer bij ons is, blijven zijn waarden elke stap die we zetten richting geven.",
        },
      },
    },
    readBio: "Lees bio",
    inMemoriam: {
      eyebrow: "Ter herinnering",
      title: "In dierbare herinnering",
      subtitle:
        "Wij eren de collega’s die met hun visie, warmte en onvermoeibare inzet een blijvende indruk hebben achtergelaten. Hun nalatenschap inspireert ons elke dag en vormt de basis van onze toekomst.",
      badge: "In Memoriam",
      readLegacy: "Lees hun verhaal",
    },
    companyStory:
      "Aniel was het zat om moeite te hebben met het boeken van betaalbare vluchten voor zijn vakanties. In plaats van op te geven, kreeg hij een idee dat de wereld kon veranderen. Hij ontwikkelde zijn eigen zoekmachine voor vluchten en begon daarmee aan een spannende reis die de manier waarop mensen naar vluchten zoeken zou vernieuwen. Hij bouwde een platform dat niet alleen de goedkoopste vluchten vindt, maar reizigers wereldwijd ook een soepele boekingservaring biedt. Van een simpel idee naar een wereldwijde oplossing: zijn passie en harde werk hebben vliegen toegankelijker en betaalbaarder gemaakt voor iedereen.",
    discoverMore: "Ontdek meer",
    questionDescription:
      "Met razendsnelle caching en eenvoudig te implementeren API's is het verspreiden van onze content heel eenvoudig. We bieden maatwerkoplossingen voor elke markt",
    questions: {
      virtualInterlining: "Wat is Virtual Interlining?",
      airline: "Ik ben een luchtvaartmaatschappij",
      airport: "Ik ben een luchthaven",
      carrier: "Ik ben een land- of zeevervoerder",
      retailer: "Ik ben een reisverkoper",
      affiliate: "Ik wil affiliate worden",
      provider: "Ik ben een reisserviceprovider",
    },
    history: {
      october2007: {
        date: "Oktober 2007",
        description:
          "In oktober 2007 begint Aniel zijn reis in de reisbranche met een visie om een bedrijf op te bouwen dat de manier waarop mensen reizen vernieuwt. Hij lanceert Satyam Tours en zet zijn missie in gang.",
      },
      december2007: {
        date: "December 2007",
        description:
          "Satyam Tours wordt IATA-gecertificeerd, een belangrijke mijlpaal in de groei en geloofwaardigheid van het bedrijf.",
      },
      april2010: {
        date: "April 2010",
        description:
          "Satyam Tours vergroot zijn internationale bereik door een vestiging in Nederland te openen, waarmee het zijn positie als toonaangevende speler in de reisbranche versterkt.",
      },
      may2011: {
        date: "Mei 2011",
        description:
          "Satyam Tours opent een vestiging in India, die direct een succes wordt. Aniels innovatieve ideeen en toewijding aan klanttevredenheid winnen het vertrouwen van reizigers, en Satyam Tours wordt een bekende naam in de Indiase reisbranche.",
      },
      august2013: {
        date: "Augustus 2013",
        description:
          "Satyam Tours blijft uitbreiden met vier extra vestigingen in Suriname en versterkt daarmee zijn reputatie als belangrijke speler in de reisbranche.",
      },
      december2021: {
        date: "December 2021",
        description:
          "Aniel brengt Satyam Tours naar een volgend niveau door een nieuwe vestiging op Curacao te openen, waarmee het bedrijf zijn bereik vergroot en innovatieve diensten naar een nieuwe markt brengt.",
      },
      october2022: {
        date: "Oktober 2022",
        description:
          "Satyam Tours ontvangt ANVR-, SGR- en Calamiteitenfonds-certificeringen, als erkenning voor de inzet van het bedrijf voor kwaliteit en excellentie.",
      },
      march2023: {
        date: "Maart 2023",
        description:
          "In maart 2023 lanceert Satyam Tours zijn betaversie voor het publiek. Voor het eerst kunnen gebruikers rechtstreeks via de website vluchten zoeken en gebruikmaken van geavanceerde kunstmatige intelligentie, waardoor het boekingsproces verder wordt gestroomlijnd en de reiservaring nog beter wordt.",
      },
    },
  },
  entryFee: {
    hero: {
      eyebrow: "Entry fee",
      title: "Vraag je entry fee aan",
      subtitle:
        "Een kort formulier, een paspoortscan en daarna betaling. De meeste aanvragen worden dezelfde dag verwerkt.",
    },
    steps: {
      apply: "Aanvragen",
      applyHint: "Gegevens reiziger",
      uploadPassport: "Paspoort uploaden",
      uploadHint: "Paspoortscan",
      payment: "Betaling",
      paymentHint: "Betaal met Tikkie",
    },
    errors: {
      generic: "Er is iets misgegaan. Probeer het opnieuw!",
    },
    form: {
      title: "Vul de velden in om door te gaan",
      lead: "Gebruik dezelfde gegevens als in het paspoort. We hebben deze nodig voor de entry voucher.",
      travelSection: "Reis",
      travelerSection: "Reiziger",
      continue: "Doorgaan",
      back: "Terug",
      thisField: "Dit veld",
      dayOfArrival: "Aankomstdag",
      ticketPurchasedFromUs: "Ticket bij ons gekocht",
      isEmergency: "Spoedaanvraag",
      gender: "Geslacht",
      male: "Man",
      female: "Vrouw",
      passportNumber: "Paspoortnummer",
      scanTitle: "Paspoort scannen",
      scanHint:
        "Upload een duidelijke foto van de datapagina. Wij vullen de reizigersgegevens in.",
      scanAgainHint: "Scan opnieuw als je de huidige gegevens wilt vervangen.",
      scanAction: "Paspoort scannen",
      scanAgain: "Opnieuw scannen",
      fillManually: "Of vul de reizigersgegevens zelf in",
      scannedNote:
        "Gegevens uit je paspoort. Controleer ze en pas aan wat niet klopt.",
      chooseTravelerMethod:
        "Scan een paspoort of vul de reizigersgegevens in om door te gaan.",
      datePlaceholder: "DD/MM/JJJJ",
      openCalendar: "Kalender openen",
    },
    upload: {
      title: "Upload je paspoort!",
      lead: "Een duidelijke kleurenfoto of scan van de datapagina is voldoende. Geen vinger op de pagina.",
      readyTitle: "Paspoort klaar",
      readyLead:
        "We hebben het paspoort dat je hebt gescand al. Ga door, of vervang het als je een scherpere foto wilt.",
      label: "Upload je paspoort.",
      submit: "Doorgaan naar betaling",
    },
    payment: {
      title: "Betaal met Tikkie om het proces af te ronden",
      lead: "Je aanvraag is klaar. Rond de betaling af om de entry voucher te ontvangen.",
      newApplication: "Nieuwe aanvraag?",
    },
    aside: {
      feeTitle: "Entry fee",
      feeText:
        "De standaardverwerking is EUR 70 per persoon, te betalen na de aanvraag.",
      timeTitle: "Doorlooptijd",
      timeText:
        "Vraag bij voorkeur minstens een maand voor vertrek aan. Veel vouchers komen binnen enkele uren.",
      validTitle: "Geldigheid",
      validText:
        "De voucher is 90 dagen geldig vanaf uitgifte. Het paspoort moet minstens zes maanden geldig zijn.",
    },
  },
  jobs: {
    heroTitle: "Bouw je carrière in reizen",
    heroSubtitle:
      "Sluit je aan bij een team dat mensen verbindt in Suriname, het Caribisch gebied en Europa. Vind een rol die past bij hoe jij wilt groeien.",
    filterJob: "Functie",
    filterDepartment: "Afdeling",
    filterLocation: "Locatie",
    selectJob: "Alle functies",
    selectDepartment: "Alle afdelingen",
    selectLocation: "Alle locaties",
    noResults: "Geen opties beschikbaar",
    search: "Zoeken",
    reset: "Reset",
    openPositions: "Openstaande vacatures",
    openPositionsHint: "Tik op een rol voor details en solliciteren.",
    openRole: "{{count}} openstaande rol",
    openRoles: "{{count}} openstaande rollen",
    viewRole: "Bekijk rol",
    emptyTitle: "Momenteel geen openstaande vacatures",
    emptyMessage:
      "Er zijn nu geen passende rollen. Kom snel terug — er komen regelmatig nieuwe kansen bij.",
    backToJobs: "Terug naar vacatures",
    roleOverview: "Functieoverzicht",
    applyHint:
      "Beantwoord eerst de vragenlijst en upload daarna je documenten om je sollicitatie af te ronden.",
    uploadRequired: "Upload zowel je cv als motivatiebrief voordat je indient.",
    applyFailed:
      "Je sollicitatie kon niet worden verzonden. Probeer het opnieuw.",
    loginRequired: "Log in om je sollicitatie in te dienen.",
    errorMessage:
      "Deze vacature kon niet worden geladen. Probeer het later opnieuw.",
    shareListing: "Deel deze vacature",
    shareEmailBody:
      "Ik dacht dat je interesse zou kunnen hebben in deze rol bij Satyam:",
    applyNow: "Solliciteer nu",
    uploadResume: "Upload je cv",
    uploadMotivation: "Upload je motivatiebrief",
    dropFileHint: "Sleep je bestand hierheen, of klik om te bladeren",
    dropFileActive: "Laat je bestand los om te uploaden",
    removeFile: "Bestand verwijderen",
    applicationSuccess:
      "Gefeliciteerd! Je sollicitatie is succesvol verzonden!",
    diversityNote:
      "Bij ons bedrijf is diversiteit onze kracht. We verwelkomen en waarderen iedereen, ongeacht gender, afkomst of beperking, en geloven in het potentieel van elke sollicitant. Sluit je bij ons aan en bouw mee aan een inclusieve toekomst.",
    stepper: {
      questionnaire: "Vragenlijst",
      documents: "Documenten",
      done: "Klaar",
      guideline:
        "Elke vraag beantwoordt u in maximaal 75 tot 100 woorden. Wij rekenen erop dat u eerlijke en concrete antwoorden geeft. Gebruik waar mogelijk een voorbeeld uit werk, school, stage, vrijwilligerswerk of een privésituatie.",
      questionOf: "Vraag {{current}} van {{total}}",
      answeredCount: "{{count}}/{{total}} beantwoord",
      answerPlaceholder: "Schrijf hier je antwoord...",
      wordCount: "{{count}} woorden · streef naar {{min}}–{{max}}",
      answerRequired: "Beantwoord deze vraag voordat je doorgaat.",
      tooManyWords: "Houd je antwoord tot maximaal {{max}} woorden.",
      back: "Terug",
      next: "Volgende vraag",
      continueToDocuments: "Ga verder naar documenten",
      uploadTitle: "Upload je documenten",
      uploadHint:
        "Voeg je cv en motivatiebrief toe. We bewaren deze veilig samen met je antwoorden.",
      submitApplication: "Sollicitatie indienen",
      successHint:
        "Bedankt voor je sollicitatie. Ons rekruteringsteam bekijkt binnenkort je antwoorden en documenten.",
      seeHiringProcess: "Bekijk hoe wij aannemen",
    },
    questions: {
      q1: "Waarom wil je bij Satyam Holidays werken en wat denk jij in deze functie te kunnen bijdragen?",
      q2: "Beschrijf een situatie waarin je uit eigen initiatief verantwoordelijkheid nam voor een taak, probleem of resultaat. Wat deed je en wat was het resultaat?",
      q3: "Iemand wacht op informatie, een actie of een resultaat van jou, maar je hebt nog niet alles wat je nodig hebt. Hoe zorg je voor duidelijke communicatie en tijdige opvolging?",
      q4: "Beschrijf een fout of vergissing die je hebt gemaakt. Hoe ben je ermee omgegaan en wat heb je gedaan om herhaling te voorkomen?",
      q5: "Geef een voorbeeld van iets nieuws dat je moest leren, zoals een systeem, programma, proces of werkwijze. Hoe heb je dit aangepakt en hoe controleerde je of je het goed toepaste?",
      q6: "Je hebt meerdere belangrijke taken met deadlines en een collega vraagt om hulp. Hoe bepaal je wat prioriteit heeft en welke actie je onderneemt?",
    },
  },
  schedules: {
    heroEyebrow: "Live bord",
    heroTitle: "Vluchtschema's",
    heroSubtitle:
      "Aankomsten en vertrekken voor Suriname, Curaçao en Nederland. Wordt elke vier uur bijgewerkt.",
    suriname: "Suriname",
    curacao: "Curaçao",
    netherlands: "Nederland",
    arrivals: "Aankomsten",
    departures: "Vertrekken",
    lastUpdated: "Laatst bijgewerkt",
    lastUpdatedHint: "Dit bord wordt elke 4 uur vernieuwd.",
    flightCount: "{{count}} vluchten",
    flightCountOne: "1 vlucht",
    emptyTitle: "Geen {{type}} op dit moment",
    emptyMessage:
      "Kom over een paar uur terug. Dit bord wordt elke vier uur bijgewerkt.",
    errorTitle: "Het vluchtschema kon niet worden geladen",
    errorMessage: "Probeer het zo opnieuw.",
    from: "Van",
    to: "Naar",
  },
  howWeHire: {
    intro:
      "Wij zoeken iemand die niet alleen de juiste skills heeft, maar ook onze visie deelt. We willen dat jij net zo enthousiast bent om hier te werken als wij. Om bij onze cultuur te passen, waardeer je samenwerking boven concurrentie en hou je van een uitdaging. Elk gesprek is een beetje anders, net als onze recruiters, managers en kandidaten. Je verpest je kansen niet door eerlijk te zijn of jezelf te zijn. Hoe ziet het proces eruit?",
    steps: {
      cvEvaluation: {
        title: "CV-beoordeling",
        description:
          "Eerst bekijken we zorgvuldig je cv en motivatiebrief om te zien of we bij elkaar passen.",
      },
      videoCall: {
        title: "Videogesprek",
        description:
          "Als je ervaring aansluit bij de functie, plannen we een videogesprek of telefoongesprek om elkaar beter te leren kennen.",
      },
      practicalTask: {
        title: "Praktische opdracht",
        description:
          "Voor technische rollen hebben we verschillende praktische opdrachten. Dat kan huiswerk zijn of een live coding sessie. Voor klantenservice toetsen we je taalvaardigheid via een online platform, direct na het videogesprek.",
      },
      interview: {
        title: "Interview",
        description:
          "Na de praktische opdracht nodigen we je uit voor 1 of 2 interviews, waarin je je toekomstige manager ontmoet en meer te weten komt over de rol binnen ons bedrijf.",
      },
      jobOffer: {
        title: "Aanbod",
        description:
          "Op dit punt weet je al veel over de functie en wat je kunt verwachten. Dan volgt de formele laatste stap, en daarna heten we je graag welkom in het team.",
      },
    },
  },
  helpDesk: {
    launcher: "Helpdesk",
    support: "WhatsApp support",
    title: "Chat met onze reisexperts",
    description:
      "Kies het kantoor dat het dichtst bij je is en we zetten het gesprek voort via WhatsApp.",
    status: "Online · Reageert meestal binnen enkele minuten",
    redirectNotice:
      "Wanneer je een chat start, word je doorgestuurd naar WhatsApp.",
    chat: "Chat",
    offices: {
      suriname: {
        country: "Suriname",
        location: "Paramaribo · Hoofdkantoor",
      },
      netherlands: {
        country: "Nederland",
        location: "Den Haag · Europa kantoor",
      },
      curacao: {
        country: "Curacao",
        location: "Willemstad · Caribbean desk",
      },
    },
  },
  reservedFlight: {
    flightDetails: "Vluchtgegevens",
    travelers: "Reizigers",
    paymentInfo: "Betaalinformatie",
    remarks: "Opmerkingen",
    contacts: "Contacten",
    moreInfo: "Meer info",
    cabin: "Cabine",
    class: "Klasse",
    aircraft: "Vliegtuig",
    carrierCode: "Maatschappijcode",
    bookingStatus: "Boekingsstatus",
    number: "Nummer",
    segmentType: "Segmenttype",
    numberOfStops: "Aantal stops",
    seating: "Stoelen",
    layoverIn: "Tussenstop in {{airport}}",
    priceDetails: "Prijsdetails",
    nethPrice: "Netto prijs",
    totalPrice: "Totale prijs",
    grandTotal: "Eindtotaal",
    generalRemarks: "Algemene opmerkingen",
  },
  packageDeals: {
    title: "Pakketreizen",
    pageSubtitle:
      "Ontdek onze geselecteerde vakantiepakketten. Klik op een aanbieding voor het volledige reisprogramma en een reserveringsaanvraag.",
    loadError:
      "Pakketreizen konden niet worden geladen. Probeer het later opnieuw.",
    empty: "Er zijn momenteel geen pakketreizen beschikbaar.",
    featured: "Uitgelicht",
    from: "Vanaf",
    night: "nacht",
    nights: "nachten",
    person: "persoon",
    people: "personen",
    viewTravelProgramme: "Bekijk reisprogramma",
    valid: "Geldig",
    whatsIncluded: "Wat is inbegrepen",
    whatsExcluded: "Wat is niet inbegrepen",
    maxParticipants: "Max {{count}} deelnemers",
    requestReservation: "Reservering aanvragen",
    tripLoading: "Je reis wordt geladen...",
    detailsLoadErrorTitle: "Dit pakket kon niet worden geladen",
    detailsLoadErrorDescription:
      "Probeer het later opnieuw of neem contact met ons op.",
    backToTours: "Terug naar pakketreizen",
    aboutPackage: "Over dit pakket",
    peopleQuestion: "Met hoeveel personen reis je?",
    groupSizeHint: "Selecteer je groepsgrootte in de dropdown hieronder",
    roomOptions: "Kameropties",
    roomOptionsDescription:
      "Kies je gewenste kamerindeling. Prijzen zijn totaal voor alle {{count}} {{people}}.",
    total: "Totaal",
    travelProgramme: "Je reisprogramma",
    day: "Dag {{day}}",
    included: "Inbegrepen",
    notIncluded: "Niet inbegrepen",
    bookTour: "Boek reis",
  },
  home: {
    welcome: "Welkom",
    heroSubtitle:
      "Geluk kun je niet kopen, maar vliegtickets wel, en dat komt aardig in de buurt.",
    packageSubtitle:
      "Geselecteerde vakantiepakketten. Klik op een aanbieding voor het volledige reisprogramma.",
    viewAll: "Alles bekijken",
    dealsEyebrow: "Zorgvuldig geselecteerd",
    appComingSoon: "De mobiele app komt eraan",
    appBrand: "Satyam Holidays",
    appRelease: "Lancering over 3-4 weken",
    appSubtitle:
      "Zoek vluchten, boek vakanties en beheer je reizen. De Satyam Holidays-app neemt de volledige boekingservaring met je mee.",
    appPhoneTag: "Vluchten • Vakanties • Inchecken",
    appStores: "Binnenkort in de App Store en Google Play",
    appStore: "App Store",
    playStore: "Google Play",
    appPhoneSearch: "Waarheen nu?",
    searchCheapestFlights: "Zoek de goedkoopste vluchten",
    seatSelections: "Stoelkeuze",
    freeReservations: "Gratis online reserveringen",
    liveSchedules: "Bekijk live vluchtschema's",
    popularDestinations: "Populaire bestemmingen",
    popularEyebrow: "Toproutes",
    popularSubtitle:
      "De routes waar onze reizigers het meest van houden, met scherpe tarieven het hele jaar door.",
    partnersTitle: "Vertrouwd en erkend door",
    heroChips: {
      secure: "Veilig betalen",
      support: "24/7 persoonlijke support",
      iata: "IATA-geaccrediteerd agent",
    },
    showMore: "Meer tonen",
    supportEyebrow: "Reisondersteuning",
    supportTitle: "Wil je je reis aanpassen? Wij maken het eenvoudig.",
    supportSubtitle:
      "Van wijzigingen tot bagagevragen: ons team helpt je reisplannen duidelijk en zorgeloos te houden.",
    supportCards: {
      change: {
        label: "Flexibele plannen",
        title: "Pas je boeking met vertrouwen aan",
        body: "Plannen kunnen veranderen. Wij helpen je de opties te begrijpen en begeleiden je bij de volgende stap.",
      },
      help: {
        label: "Slim vergelijken",
        title: "Gebruik de prijstabel om je beste optie te vinden",
        body: "Vergelijk reisdatums en prijzen in een oogopslag, zodat je eenvoudig het tarief kiest dat het beste past.",
      },
      baggage: {
        label: "Slimme tarieven",
        title: "Vind betere waarde met bagage inbegrepen",
        body: "Gebruik de bagagefilters tijdens het zoeken om tarieven te vergelijken waarbij ruimbagage al inbegrepen is.",
      },
    },
    paymentMethods: {
      eyebrow: "Flexibel betalen",
      title: "Betaal op jouw manier, veilig en eenvoudig",
      subtitle:
        "Kies de betaalmethode die het beste bij je past. Van kaarten tot lokale betaalopties: afrekenen gaat eenvoudig en veilig.",
      securityNote: "PCI DSS Level 1-conforme betalingsverwerking.",
      klarnaSpotlight: {
        badge: "Alleen bij Satyam Tours",
        title: "Boek nu, betaal later met Klarna",
        body: "Reserveer je reis met meer flexibiliteit en kies BNPL bij het afrekenen wanneer beschikbaar.",
        note: "Beschikbaarheid hangt af van je boeking en gekozen betaalopties.",
      },
      methods: {
        klarna: {
          title: "Klarna BNPL",
          body: "Boek nu en betaal later wanneer deze optie beschikbaar is bij het afrekenen.",
        },
        creditCard: {
          title: "Creditcard",
          body: "Betaal veilig met bekende kaarten via onze beveiligde checkout.",
        },
        ideal: {
          title: "iDEAL",
          body: "Gebruik een vertrouwde Nederlandse betaalmethode voor snel betalen via je bank.",
        },
        tikkie: {
          title: "Tikkie",
          body: "Open je Tikkie-link en rond de betaling eenvoudig af vanaf je telefoon.",
        },
        applePay: {
          title: "Apple Pay",
          body: "Reken snel af met de kaarten die op je Apple-apparaat staan.",
        },
        sepa: {
          title: "SEPA",
          body: "Betaal rechtstreeks vanaf ondersteunde Europese bankrekeningen.",
        },
        cartesBancaires: {
          title: "Cartes Bancaires",
          body: "Gebruik een vertrouwd Frans kaartnetwerk wanneer dit beschikbaar is.",
        },
        blik: {
          title: "Blik",
          body: "Rond je betaling af met een snelle mobiele bankcode.",
        },
        bancontact: {
          title: "Bancontact",
          body: "Betaal met een populaire Belgische betaalmethode.",
        },
        mobilePay: {
          title: "MobilePay",
          body: "Gebruik een eenvoudige mobiele wallet om af te rekenen vanaf je telefoon.",
        },
        bankTransfer: {
          title: "Bankoverschrijving",
          body: "Betaal je liever handmatig? Bankoverschrijving is ook beschikbaar.",
        },
      },
    },
  },
  cars: {
    dropOffTime: "Inlevertijd",
    pickUpTime: "Ophaaltijd",
  },
  banner: {
    flights: "Vluchten",
    hotels: "Hotels",
    comingSoon: "Binnenkort",
    quickRoutes: "Populaire routes",
    quickRoutesShow: "Tonen",
    quickRoutesHide: "Verbergen",
    filters: "Filters",
    from: "Van",
    to: "Naar",
    destination: "Bestemming",
    departureDate: "Vertrekdatum",
    checkIn: "Inchecken",
    checkOut: "Uitchecken",
    trip: "Reis {{number}}",
    letsGo: "Zoeken",
    addDestination: "Bestemming toevoegen",
    refundableFare: "Restitueerbaar tarief",
    return: "Retour",
    oneWay: "Enkele reis",
    multiCity: "Meerdere steden",
    economy: "Economy",
    premiumEconomy: "Premium Economy",
    business: "Business",
    firstClass: "First Class",
    passengers: "Passagiers",
    senior: "Senior",
    adults: "Volwassenen",
    children: "Kinderen",
    infants: "Baby's",
    bags: "Bagage",
    checked: "Ingecheckt",
    checkedBaggage: "Ruimbagage",
    adult: "Volwassene",
    howManyRooms: "Aantal kamers",
  },
  filters: {
    officeId: "Office ID",
    refundableFare: "Restitueerbaar tarief",
    refundFare: "Restitutie tarief",
    baggage: "Bagage",
    checkedBaggage: "Ruimbagage",
    twoCheckedBaggage: "2x Ruimbagage",
    cabinType: "Cabineklasse",
    economy: "Economy",
    premiumEconomy: "Premium Economy",
    business: "Business",
    firstClass: "First Class",
    stops: "Stops",
    nonStop: "Non-stop (direct)",
    upToOneStop: "Tot 1 stop",
    upToTwoStops: "Tot 2 stops",
  },
  resultCard: {
    priceDrop: "Prijsverlaging",
    targetFlight: "Vlucht targeten",
    linkCopied: "Link gekopieerd!",
    copyLink: "Link kopieren",
    analyze: "Analyseren",
    days: "{{count}} Dagen",
    showDetails: "Details tonen",
    shareQuote: "Offerte delen",
    shareQuoteSubtitle:
      "Controleer het tarief en download een offerte-afbeelding om te delen met je klant.",
    shareQuoteRoute: "Reisroute",
    shareQuoteDownload: "Offerte downloaden",
    viewRules: "Regels bekijken",
    seatsLeft: "{{count}} Stoelen over",
    copyFlightLink: "Vluchtlink kopieren",
    copyError: "Er is iets misgegaan. Probeer het opnieuw.",
    targetedSuccess: "De vlucht is succesvol getarget",
    error: "Er is een fout opgetreden",
    description: "Beschrijving",
    totalBankPrice: "Totale bankprijs ({{currency}})",
    totalCashPrice: "Totale contantprijs ({{currency}})",
  },
  sidebar: {
    title: "Wil je nog voordeliger vliegen?",
    description:
      "Probeer de 2x ruimbagage-filter om Satyam Special tarieven met meer bagage te vinden.",
    cta: "Probeer 2x ruimbagage",
    defaultTitle: "Reis voordeliger met Satyam",
    defaultDescription:
      "Vergelijk flexibele datums, bagageopties en pakketreizen om het tarief te vinden dat het beste bij je reis past.",
    activeBadge: "Filter actief",
    activeTitle: "2x ruimbagage is actief",
    activeDescription:
      "Je bekijkt nu Satyam Special tarieven met twee ingecheckte koffers inbegrepen.",
    activeCta: "2x ruimbagage geselecteerd",
  },
  noBaggageModal: {
    title: "Geen ruimbagage inbegrepen",
    description:
      "Dit tarief is geprijsd zonder ruimbagage. Selecteer een van de filters hieronder om opties met bagage te vergelijken.",
    sectionLabel: "Toon tarieven met bagage",
    twoBagsDescription:
      "Bekijk Satyam Special tarieven met twee ingecheckte koffers inbegrepen.",
    oneBagDescription: "Bekijk tarieven met minimaal een ingecheckte koffer.",
    continue: "Doorgaan zonder bagage",
    recommended: "Aanbevolen",
  },
  booking: {
    steps: {
      search: "Zoeken",
      passengerDetails: "Passagiersgegevens",
      seatMap: "Stoelkeuze",
      overviewPayment: "Overzicht & betaling",
    },
    labels: {
      tripSummary: "Reisoverzicht",
      trip: "Reis {{number}}",
      departure: "Vertrek",
      return: "Terugreis",
      duration: "Duur",
      flightNo: "Vluchtnummer",
      airline: "Luchtvaartmaatschappij",
      aircraft: "Vliegtuig",
      travelersInfo: "Reizigersgegevens",
      primaryPassenger: "Hoofdpassagier ({{type}})",
      firstName: "Voornaam",
      lastName: "Achternaam",
      dateOfBirth: "Geboortedatum",
      gender: "Geslacht",
      email: "E-mail",
      phoneNumber: "Telefoonnummer",
      passportNumber: "Paspoortnummer",
      passportExpirationDate: "Vervaldatum paspoort",
      issuanceCountry: "Land van afgifte",
      nationality: "Nationaliteit",
      checkedBags: "Ruimbagage",
      checkedBag: "Ruimbagage",
      included: "Inbegrepen",
      numberOfPassengers: "Aantal passagiers",
      passenger: "Passagier",
      seatFor: "{{type}} stoel voor {{name}}",
      packageDeal: "Pakketreis",
      packageDealBooking:
        "Pakketreisboeking - pakketprijs: {{currency}}{{price}} inbegrepen in totaal",
      total: "Totaal ({{currency}})",
      priceSummary: "Prijsoverzicht",
      secureNote: "Veilig boeken — geen verborgen kosten",
      taxesAndFees: "Belastingen & toeslagen",
      noHiddenCosts: "Geen verborgen kosten",
      secureBooking: "Veilig en betrouwbaar boeken",
      person: "persoon",
      people: "personen",
      single: "Single",
      double: "Double",
      triple: "Triple",
      quad: "Quad",
      overview: "Overzicht",
      itinerary: "Reisroute",
      passengers: "Passagiers",
      flight: "vlucht",
      flights: "vluchten",
      direct: "Direct",
      stopCount: "{{count}} tussenstop",
      showFlightDetails: "Toon details",
      hideFlightDetails: "Verberg details",
      step1Eyebrow: "Stap 1 · Reizigersgegevens",
      step4Eyebrow: "Stap 4 · Overzicht & betaling",
      readyToConfirm: "Klaar om te bevestigen",
      travelerCard: "Reiziger {{number}}",
      personalDetails: "Persoonsgegevens",
      contactDetails: "Contactgegevens",
      travelDocuments: "Reisdocumenten",
      scanPassport: "Paspoort scannen",
      scanningTitle: "Paspoort scannen…",
      scanningHint: "Even geduld, we lezen de gegevens veilig uit.",
      scanConfidence: "Scankwaliteit",
      confirmations: "Bevestigingen",
      consentProgress: "{{count}} van 3 bevestigd",
      readyToContinue: "Klaar voor de volgende stap",
      travelerReady: "{{count}} reizigers",
      baggage: "Bagage",
      personalItem: "Persoonlijk item",
      seating: "Stoelen",
      specificSeat: "specifieke stoel",
    },
    travelerTypes: {
      ADULT: "Volwassene",
      CHILD: "Kind",
      HELD_INFANT: "Baby",
      SENIOR: "Senior",
    },
    options: {
      male: "Man",
      female: "Vrouw",
    },
    messages: {
      noBaggage:
        "Let op: deze reservering bevat geen bagage. Bel ons of stuur een e-mail met je referentie-ID om bagage toe te voegen aan je reservering.",
      uploadPassport:
        "Upload of kies een duidelijke afbeelding van het paspoort om reizigersgegevens in te vullen.",
      travelersHint: "Vul elke naam exact in zoals die op het paspoort staat.",
      reviewHint:
        "Controleer elke reiziger en vlucht voordat je de reservering bevestigt.",
      confirmHint:
        "Je boeking wordt aangemaakt nadat je de reservering plaatst.",
      sameEmailPhone: "Gebruik hetzelfde e-mailadres en telefoonnummer",
      verifyInfo:
        "Ik heb gecontroleerd dat alle informatie op dit formulier correct is.",
      scannerNotice:
        "Ik erken dat als de paspoortafbeelding niet duidelijk zichtbaar is, de scanner ongeldige gegevens kan hebben gegenereerd en dat ik deze indien nodig moet aanpassen.",
      visaNotice:
        "Ik heb gecontroleerd dat ik een geldig visum heb of geen visum nodig heb om naar {{destination}} te reizen",
      visaDuration:
        "voor de duur van {{days}} dagen zoals aangegeven in mijn reservering.",
      seatMapUnavailable:
        "De stoelkaart is momenteel niet beschikbaar bij de luchtvaartmaatschappij. Kies een stoel op de luchthaven tijdens het inchecken.",
      reservationError: "Sorry, er is iets misgegaan! Probeer het opnieuw.",
      reservationLoading: "We zetten je reservering vast",
      reservationLoadingDescription:
        "Houd deze pagina open terwijl we je vluchtgegevens bevestigen.",
      reservationLoadingTipTitle: "Wist je dat?",
      reservationLoadingTip:
        "Je kunt vaak voordeliger vliegen door te zoeken met de 2x ruimbagage-filter.",
      expirationMissing:
        "De vertrekdatum ontbreekt of is niet beschikbaar. Controleer de vluchtgegevens.",
      expirationIncomplete:
        "De velden voor de vervaldatum zijn niet compleet. Vul alle datumgegevens in.",
      expirationInvalidFormat:
        "Ongeldig formaat voor de vervaldatum. Controleer de datum.",
      travelerExpirationUnverified:
        "Reiziger {{number}}: de vervaldatum van het paspoort kon niet worden gecontroleerd. De gescande datum kan onjuist zijn.",
      travelerExpirationWarning:
        "Reiziger {{number}}: het paspoort verloopt op {{date}}, binnen 6 maanden na de vertrekdatum.",
    },
    validation: {
      lettersOnly: "Mag alleen letters bevatten",
      expirationRequired: "Vervaldatum paspoort is verplicht",
      expirationInvalid: "Vervaldatum paspoort is ongeldig!",
      invalidIssuanceCountry: "Ongeldig land van afgifte",
      documentsRequired: "Documenten zijn verplicht",
      phoneInvalid: "Telefoonnummer is ongeldig",
    },
    seats: {
      title: "Kies je stoelen",
      description: "Vind de meest comfortabele stoelen voor je gezelschap.",
      selectOnMap: "Kies een stoel op de kaart",
      available: "Beschikbaar",
      blocked: "Geblokkeerd of bezet",
      selected: "Geselecteerd",
      skip: "Stoelen overslaan en doorgaan",
    },
    actions: {
      continue: "Doorgaan",
      placeReservation: "Reservering plaatsen",
      days: "{{count}} dagen",
      addExistingTraveler: "Bestaande reiziger toevoegen",
      goBackFix: "Terug en aanpassen",
      understandContinue: "Ik begrijp het, doorgaan",
      backToResults: "Terug naar resultaten",
    },
    passportWarning: {
      title: "Melding vervaldatum paspoort",
      description:
        "We hebben een mogelijk probleem gevonden met een of meer vervaldatums van paspoorten. De meeste landen vereisen dat paspoorten nog minimaal 6 maanden geldig zijn na de reisdatum. Doorgaan met een verlopen of bijna verlopen paspoort kan leiden tot geweigerde boarding of toegang.",
      responsibility:
        "Door door te gaan bevestig je dat de reiziger(s) volledige verantwoordelijkheid accepteren om ervoor te zorgen dat hun reisdocumenten voldoen aan alle toelatingseisen voor hun bestemming.",
    },
    existingTravelers: {
      title: "Jouw reizigers",
      kicker: "Opgeslagen reizigers",
      choose: "Kies een opgeslagen reiziger",
      chooseHint: "Vul automatisch in vanuit iemand die je eerder hebt geboekt",
      change: "Wijzigen",
      use: "Gebruik",
      added: "Toegevoegd",
      applied: "Opgeslagen reiziger",
      add: "Bestaande reiziger toevoegen",
      fromModule: "Uit module",
      searchPlaceholder: "Zoek op naam, e-mail of paspoort",
      notFound: "Niet gevonden",
      noResults: 'Geen resultaten gevonden voor "{{query}}".',
      noMatches: "Geen overeenkomsten gevonden",
      noMatchesHint: 'Niets komt overeen met "{{query}}".',
      empty: "Nog geen opgeslagen reizigers",
      emptyHint: "Reizigers die je boekt verschijnen hier de volgende keer.",
      loading: "Je reizigers worden geladen…",
      unnamed: "Naamloze reiziger",
      searchHint:
        "Zoeken werkt alleen op voornaam, achternaam, paspoortnummer, e-mail of telefoonnummer",
      uploadPassport: "Upload je paspoort",
      expirationInvalid:
        "Vervaldatum paspoort moet minimaal 6 maanden na de vertrekdatum liggen!",
    },
  },
  confirmation: {
    title: "Boeking bevestigd",
    subtitleFlight:
      "Bedankt voor je reservering. Je vluchtboeking is bevestigd.",
    subtitlePackage:
      "Bedankt voor je reservering. Je vlucht en pakketreis zijn bevestigd.",
    eyebrow: "Boeking afgerond",
    referenceId: "Referentie-ID",
    copy: "Kopieren",
    copied: "Gekopieerd!",
    copyReference: "Referentie-ID kopieren",
    packageDealBooking: "Pakketreisboeking",
    packageIncluded:
      "Deze boeking bevat een pakketreis. Pakketprijs: {{currency}}{{price}} is inbegrepen in het totaalbedrag.",
    roomConfiguration: "Kamerindeling",
    packageTourDetails: "Details pakketreis",
    flightDetails: "Vluchtgegevens",
    travelersDetails: "Reizigersgegevens",
    remarks: "Opmerkingen",
    packageTour: "Pakketreis",
    paymentCharge: "Betaalkosten",
    remarkError:
      "Je opmerking is niet toegevoegd. Voeg deze opmerking handmatig toe in Sell Connect.",
    remarkSuccess: "Je opmerking is succesvol toegevoegd",
    remarkPlaceholder: "Typ je opmerking",
    remarkLabel: "Voeg je opmerking toe",
    addNewRemark: "Nieuwe opmerking toevoegen",
    submitRemark: "Opmerking verzenden",
    holdNotice:
      "Je reservering is geplaatst. Rond de betaling snel af om deze prijs te behouden en te voorkomen dat het tarief vervalt.",
  },
  payment: {
    title: "Betaling",
    completeTitle: "Rond je betaling af",
    lead: "Je reservering is geplaatst. Kies hieronder een methode om deze prijs te behouden.",
    chooseMethod: "Kies een betaalmethode",
    loading: "Betaalopties laden…",
    tikkie: "Tikkie",
    tikkieHint: "Betaal direct via Tikkie. Opent in een nieuw tabblad.",
    cashHint: "Betaal contant op kantoor.",
    methodHint: "We bevestigen deze betaling zodra we die ontvangen.",
    bankTransfers: "Bankoverschrijving",
    bankHint:
      "Maak over naar een van onze rekeningen en vermeld je referentie.",
    chooseBank: "Kies een bank",
    viewDetails: "Bekijk rekening",
    extraCharge: "Extra kosten",
    payNow: "Nu betalen",
    yourReference: "je referentienummer",
    otherMethodsTitle: "Andere betaalmethode?",
    otherMethods:
      "Neem contact met ons op en vermeld {{reference}}. We helpen je graag verder.",
    contactUs: "Neem contact op",
    cashNextTitle: "Betaal op kantoor",
    cashNext:
      "Bezoek een van onze kantoren en neem referentie {{reference}} mee. Ons team rondt de contante betaling voor je af.",
    bankNextTitle: "Betaal via bankoverschrijving",
    bankNext:
      "Kies een van de banken hieronder, maak de overschrijving met referentie {{reference}} en stuur daarna het betalingsbewijs via WhatsApp.",
    sendProofWhatsapp: "Stuur betalingsbewijs via WhatsApp",
    whatsappProofMessage:
      "Hallo, ik heb een bankoverschrijving gedaan voor reservering {{reference}}. Hier is mijn betalingsbewijs.",
  },
};

export default nl;
